import Swiper, { Pagination, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

document.querySelectorAll('.swiper.cover-images').forEach((el) => {
    const swiper = new Swiper(el, {
        modules: [Pagination, Autoplay],
        pagination: {
            el: '.swiper-pagination',
        },
        autoplay: {
            delay: 5000,
        },
        loop: true,
    });
});
